import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import { useUsersData } from '@features/users/contexts/data/useUsersData';
import { useUsersFilter } from '@features/users/contexts/filter/useUsersFilter';
import { ContentLoader } from '@shared/components/content-loader/ContentLoader';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import * as React from 'react';

import { UsersTableMobile } from './table-mobile/UsersTableMobile';
import { UsersTable } from './table/UsersTable';

const UsersContent = React.memo((): React.ReactElement => {
  const { users } = useUsersData();
  const { data, isLoading, isError } = users;
  const { isFiltersApplied } = useUsersFilter();

  const isMobileAndTablet = useMediaQuery(MediaQuery.MobileAndTablet);

  if (isLoading) {
    return <ContentLoader />;
  }

  if (isError) {
    return <InlineFeedback type="data-error" />;
  }

  if (data.elements.length === 0) {
    if (isFiltersApplied) {
      return <InlineFeedback type="no-search-results" />;
    }
    return <InlineFeedback type="so-empty" />;
  }

  return isMobileAndTablet ? <UsersTableMobile /> : <UsersTable />;
});

UsersContent.displayName = 'UsersContent';

export { UsersContent };
